// Sidebar collapse-toggle. Persistiert in localStorage; bei Bootstrap als
// data-attribute auf <html> gespiegelt damit die CSS-Breite direkt beim ersten
// Render greift (kein Layout-Flicker).

import { signal } from "@preact/signals";

const STORAGE_KEY = "juuplan:sidebar-collapsed";

const collapsedSignal = signal<boolean>(false);

export function applySidebarCollapsed(collapsed: boolean): void {
  collapsedSignal.value = collapsed;
  if (typeof document === "undefined") return;
  if (collapsed) {
    document.documentElement.setAttribute("data-sidebar", "collapsed");
  } else {
    document.documentElement.removeAttribute("data-sidebar");
  }
}

export function loadSidebarCollapsed(): boolean {
  if (typeof localStorage === "undefined") return false;
  return localStorage.getItem(STORAGE_KEY) === "1";
}

export function saveSidebarCollapsed(collapsed: boolean): void {
  if (typeof localStorage === "undefined") return;
  if (collapsed) localStorage.setItem(STORAGE_KEY, "1");
  else localStorage.removeItem(STORAGE_KEY);
  applySidebarCollapsed(collapsed);
}

export function useSidebarCollapsed(): boolean {
  return collapsedSignal.value;
}

export function bootstrapSidebar(): void {
  applySidebarCollapsed(loadSidebarCollapsed());
}
